import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { UbsBlogService } from '../../services/ubs-blog.service';
import { UbsBlogStoreService } from '../../services/ubs-blog-store.service';
//import { getCurrentRouteState } from '@urbannex/blog/lib/router-store/selectors';
//import { BlogEntry, UbsBlogStoreService } from '@urbannex/blog/src/lib/services';
//import { ConfigurationService, WebSiteConfig } from '@urbannex/configuration';
import { of as observableOf,Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BlogEntry } from '../../services/ubs-blog-model';
import { ConfigurationService, WebSiteConfig } from '@urbannex/configuration';


@Component({
  selector: 'ubs-blog',
  templateUrl: './ubs-blog.component.html',
  styleUrls: ['./ubs-blog.component.scss'],
  providers:[UbsBlogStoreService],
  encapsulation: ViewEncapsulation.None,
})
export class UbsBlogComponent implements OnInit {
  //@Input() articleData:String;
  date:string;
  //@Input() content:any;

  vm$ = this.store.vm$;
  imageUrl:string;
  contentName:string;
  //webSiteConfig$ = this.configurationService.selectWebSiteConfig();
  configSubscription:Subscription;
  webSiteConfig:WebSiteConfig;
  //blogContentId :string;// = {"blogContentId":"DISSERTATION_BLOG"};
  blogContentIdSubscription:Subscription;
  blogContentId:string;// = "KWIKECOSYSTEM";
  multiBlog:boolean = false;

  constructor(private store:UbsBlogStoreService,
    private route:ActivatedRoute,
    private ubsBlogService:UbsBlogService,
    @Inject('configurationService') private configurationService:ConfigurationService) { }

  ngOnInit(): void {
    this.configSubscription = this.configurationService.selectWebSiteConfig().subscribe(webSiteConfig =>{
      //console.log(webSiteConfig);
      this.webSiteConfig = webSiteConfig;
      if(webSiteConfig["webSiteContent"]){
        let filteredBlogs = webSiteConfig["webSiteContent"].filter((webSiteContent) => webSiteContent.webSiteContentTypeId === "BLOG_ROOT");
        if(filteredBlogs.length > 1){
          this.multiBlog = true;
        }
        this.updateBlogs(filteredBlogs);
      }
      let contentId = "";
      let blogContentId$ = null;
      if(webSiteConfig["webSite"]){
        //Check parameters for blogContentId & contentId
        this.route.paramMap.subscribe((params) => {
          if(params.get("blogContentId")){
            this.blogContentId = params.get("blogContentId");
            blogContentId$ = {"blogContentId":params.get("blogContentId")};
            if(params.get("contentId")){
              this.store.noShowFirstEntry();
              this.store.loadBlogEntries(blogContentId$);
              contentId = params.get("contentId");
              //create Url to fectch blogEntry
              this.store.blogEntries$.subscribe((data) => {
                //Check if blogEntry is in collection
                let blogEntryExits = data.find(element => element.contentId === contentId);
                if(blogEntryExits){
                  this.ubsBlogService.getBlogEntry(this.blogContentId,contentId)
                    .subscribe(data => {
                      this.store.updateSelectedBlogEntry(data);
                      this.setSelectedArticle();
                    });
                }
              })
            }else{
              //this.store.showFirstEntry();
              console.log("loading blogEntries");
              this.store.loadBlogEntries(blogContentId$);
              this.setSelectedArticle();
            }
          }else{
            //No params do default -get the blogContentId from webSiteConfig
            this.blogContentIdSubscription = this.getBlogContentId(webSiteConfig)
            .subscribe(blogContentId => {
              this.blogContentId = blogContentId;
              blogContentId$ = {"blogContentId":blogContentId};
              this.store.loadBlogEntries(blogContentId$);
              this.setSelectedArticle();
            })
          }
        })
      }
    });
  }

  updateBlogs(filteredBlogs):void{
    let blogs = [];
    filteredBlogs.forEach(element => {
      let blog = {};
      blog["blogContentId"] = element.contentId;
      this.getBlogContentName(element.contentId).subscribe(data => {
        //console.log(data);
        blog["contentName"] = data;
        //console.log(blog);
        blogs.push(blog);
      });
    })
    this.store.updateBlogs(blogs);
  }

  getBlogContentId(webSiteConfig:WebSiteConfig):Observable<string>{
    let webSiteContents:any[] = webSiteConfig["webSiteContent"];
    if(webSiteContents){
      let filteredBlogs = webSiteContents.filter((webSiteContent) => webSiteContent.webSiteContentTypeId === "BLOG_ROOT");
      let blogContentId = filteredBlogs[0]["contentId"];
      return observableOf(blogContentId);
    }
    
  }

  getBlogContentName(contentId):Observable<string>{
    return this.ubsBlogService.getContentName(contentId)
    .pipe(
      (map(data => {
        return data["contentName"];
      }))
    )
  }

  setSelectedArticle(){
    this.store.selectedBlogEntry$.subscribe(data => {
      //console.log(data.imageContentId);
      this.contentName = data.contentName;
      this.date = this.setContentDate(data.contentId);
      //Create imageUrl
      this.imageUrl = this.ubsBlogService.getBaseUrl()+"stream?contentId="+data.imageContentId;
      this.setTags(this.contentName,data["description"]);
    })
  }

  setContentDate(contentId:string){
    let date = ""
    this.store.blogEntries$.subscribe((data) => {
      let blogEntry = data.find(element => element.contentId === contentId);
      date = blogEntry["lastModifiedDate"];
    });
    return date;
  }

  getLinkText(blogEntry:BlogEntry){
    const titleParts = blogEntry.contentName.split(' '); 
    let linkString = "";
    titleParts.forEach((part,index) => {
      linkString=linkString+part;
      if(index+1 < titleParts.length){
        linkString=linkString+"-";
      }
    });
    return '/pages/blog/'+this.blogContentId+'/'+blogEntry.contentId+'/'+linkString;
  }

  setTags(title:string,description:string){
    let tags = [];
    let titleContent = "DissertationsZA | "+title;
    tags.push({name:"title",content:titleContent});
    tags.push({name:"description",content:description});
    tags.push({property:"og:url",content:this.getLocation()});
    tags.push({property:"og:type",content:"website"});
    tags.push({property:"og:title",content:titleContent});
    tags.push({property:"og:description",content:description});
    //twitter card
    tags.push({name:"twitter:title",content:titleContent});
    tags.push({name:"twitter:description",content:description});
    if(this.imageUrl){
      tags.push({property:"og:image",content:this.imageUrl});
      //twitter card ...
      tags.push({name:"twitter:card",content:"summary_large_image"});
      tags.push({name:"twitter:site",content:"@DissertationsZA"});
      tags.push({name:"twitter:creator",content:"@GavinMabie"});
      tags.push({property:"twitter:image",content:this.imageUrl});
    }
    this.ubsBlogService.setOGTags(tags);
  }

  getLocation(){
    let host = "";
    let port = "";
    let location = "";
    location = window.location.href;
    return location;
    /* if(this.webSiteConfig){
      if(this.webSiteConfig.webSite.httpsHost){
        host = this.webSiteConfig.webSite.httpsHost;
        port = this.webSiteConfig.webSite.httpsPort;
      }
    }else{
      if(isPlatformBrowser(this.platformId)){
        location = window.location.href;
        return location;
      }else{
        host = "localhost";
        port = "4200";
      }
    }
    if(host && port){
      if(host){
        location = host+":"+port+this.path;
      }
    }else if(host){
      location = host+this.path;
    }

    return location; */

  }

  checkMultiBlogs(webSiteConfig):Observable<boolean>{
      let filteredBlogs = webSiteConfig["webSiteContent"].filter((webSiteContent) => webSiteContent.webSiteContentTypeId === "BLOG_ROOT");
      if(filteredBlogs.length > 1){
        let multiBlog = true;
        return observableOf(multiBlog);
      }else{
        let multiBlog = false;
        return observableOf(multiBlog);
      }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.configSubscription.unsubscribe();
    if(this.blogContentIdSubscription){
      this.blogContentIdSubscription.unsubscribe();
    }
  }

}
